export const protocolWhitelist = /^\s*(https?|mailto|tel):/;
